// extracted by mini-css-extract-plugin
export var addressFields = "_nh-0";
export var animationContainer = "_nh-1";
export var footer = "_nh-2";
export var lineItems = "_nh-3";
export var modalContent = "_nh-4";
export var orderName = "_nh-5";
export var strong = "_nh-6";
export var warning = "_nh-7";